import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NewFlowBannerComponent } from '@app/new-flow/components/new-flow-banner/new-flowbanner.component';
import { GeneralDataService } from '@app/services/general/general-data.service';
import { OrquestadorService } from '@app/services/orquestador/orquestador.service';
import { OrquestadorInquilinoService } from '@app/tenant/services/OrquestadorInquilino/orquestador-inquilino.service';
import { correoConDosExtensiones, numericValidator } from '@app/utils/validadors';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { setData } from 'src/storage/general.actions';
import { selectDataByKey } from 'src/storage/general.selectors';
import { selectQuoteId } from '@app/tenant/storage/resume.selectors';
import { InactivityService } from '@app/services/inactivity/inactivity.service';

@Component({
  selector: 'app-cotizacion-pausa',
  standalone: false,
  templateUrl: './cotizacion-pausa.component.html',
  styleUrl: './cotizacion-pausa.component.scss'
})
export class CotizacionPausaComponent {
  // Reactive Forms
  PolicyHolder: FormGroup;
  PolicyHoderAlready: boolean = false;

  bitacoraId: string = '';

  leadId$: Observable<any>;
  bitacoraId$: Observable<any>;
  policyHolder$: Observable<any>;
  leadRequirement$: Observable<any>;

  asesorCode: string = '';
  serviceIsFailed: boolean = false;

  private inactivityService = inject(InactivityService);
  private subscriptions: Subscription = new Subscription();
  leadRequirement: string = '';
  isClicked: boolean = false;

  constructor(private fb: FormBuilder, private router: Router,

    private route: ActivatedRoute,

    private generalDataService: GeneralDataService,
    private orquestadorService: OrquestadorService,
    private orquestadorInquilinoService: OrquestadorInquilinoService,
    private store: Store,
  ) {
    this.policyHolder$ = this.store.select(selectDataByKey('PolicyHolder'));
    this.bitacoraId$ = this.store.select(selectDataByKey('bitacoraId'));
    this.leadId$ = this.store.select(selectDataByKey('leadId'));

     
    this.leadRequirement$ = this.store.select(selectDataByKey('leadRequirement'));
    // Initialize Contact Form
    this.PolicyHolder = this.fb.group({
      LastName: ['', [Validators.required, Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/)]],
      MobilePhone: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), numericValidator(), Validators.pattern(/^3(0[0-7]|1\d|2[0-4]|50)\d{7}$/)]],
      Mail: ['', [Validators.required, Validators.email, correoConDosExtensiones]]
    });
  }

  ngOnInit(): void {
    // Component initialization logic if needed
    console.log('cotizacion pausa');
    

    this.validateServiceFailed();

    this.subscriptions.add(
      this.policyHolder$.subscribe(data => {
        if (data) {
          this.PolicyHolder.patchValue({
            LastName: data.LastName || '',
            MobilePhone: data.MobilePhone || '',
            Mail: data.Mail || ''
          });
          this.PolicyHoderAlready = true;
        }
      }));

     this.subscriptions.add(
      this.leadRequirement$.subscribe(data => {
        if (data) {
          //debugger;
           this.leadRequirement = data;
        }
      }));

     // Suscribirse al código de asesor
    this.subscriptions.add(
      this.store.select(selectDataByKey('codigoAsesor')).subscribe(code => {
        if (code) {
          console.log('Código de asesor desde el store:', code);
          this.asesorCode = code;
        }
      })
    );  
  }

  enviarFormulario() {
    this.isClicked = true;
    if (this.PolicyHolder.valid) {
      const formValues = this.PolicyHolder.value;
      console.log('Formulario enviado', {
        LastName: formValues.LastName,
        MobilePhone: formValues.MobilePhone,
        Mail: formValues.Mail
      });
      // Aquí puedes agregar la lógica para enviar los datos

      const PolicyHolder = {
        LastName: formValues.LastName,
        MobilePhone: formValues.MobilePhone,
        Mail: formValues.Mail
      }

      this.store.dispatch(setData({
        key: 'PolicyHolder',
        value: PolicyHolder,
        merge: this.PolicyHoderAlready
      }));



      // Detectar automáticamente si es flujo de tenant o new-flow
      const currentUrl = window.location.href;
      const isTenantFlow = currentUrl.includes('/inquilino/') || currentUrl.includes('/tenant/');
      console.log('🔍 Detectando flujo en contactar asesor:', isTenantFlow ? 'TENANT' : 'NEW-FLOW');

      if (isTenantFlow) {
        // Flujo de TENANT - usar orquestador de inquilino
        console.log('📤 Usando OrquestadorInquilinoService para contactar asesor');

        // Obtener quoteId del store de tenant
        this.store.select(selectQuoteId).subscribe(quoteId => {
          const body = {
            ...PolicyHolder,
            isInactivity: true,
            quoteId: quoteId || '',
            leadStatus: '0_Descartado',
            leadRequirement: this.leadRequirement
          };

          console.log('Body para contactar asesor (tenant):', body);

          this.orquestadorInquilinoService.Lease_orchesResumesTenant(body).subscribe(response => {
            if (response) {
              localStorage.removeItem('state_service');
              this.isClicked = false;
              this.router.navigate(['seguros/hogar/arriendo/cotizador/tenemos-tus-datos']);
            }
          });
        }).unsubscribe();
      } else {
        // Flujo de NEW-FLOW - usar orquestador normal
        console.log('📤 Usando OrquestadorService para contactar asesor');

        // 🔹 Obtener las keys que se usaron en la inactividad para enviar TODOS los datos que el usuario llenó
        const inactivityKeys = this.inactivityService.getInactivityKeys();
        console.log('📋 Keys de inactividad para contactar asesor:', inactivityKeys);

        // ✅ Detectar si el lead debe marcarse como descartado (uso comercial o valor excedido)
        const isDiscardedLead = this.leadRequirement && (
          this.leadRequirement.toLowerCase().includes('comercial') ||
          this.leadRequirement.toLowerCase().includes('valor maximo') ||
          this.leadRequirement.toLowerCase().includes('uso del inmueble')
        );

        console.log('🔍 ¿Lead descartado?:', isDiscardedLead, '- Razón:', this.leadRequirement);

        const options: any = {
          keys: inactivityKeys.length > 0 ? inactivityKeys : ['PolicyHolder', 'Tenant', 'Property', 'ProductCode'],
          leadId: 'leadId',
          leadRequirement: this.leadRequirement !== '' ? this.leadRequirement : undefined,
          asesorCode: this.asesorCode !== '' ? this.asesorCode : undefined,
          bitacoraId: this.bitacoraId !== '' ? this.bitacoraId : undefined,
          screenPercentage: "5",
          // ✅ Agregar leadStatus cuando sea uso comercial o valor excedido
          leadStatus: isDiscardedLead ? '0_Descartado' : undefined
        };

        console.log('📤 Options para getbody en contactar asesor:', options);

        this.generalDataService.getbody(options).subscribe(body => {
          console.log('Generated body para contactar asesor:', body);
          console.log('📋 Datos en body:', {
            tienePolicyHolder: !!body.productsConfigurationData?.PolicyHolder,
            tieneTenant: !!body.productsConfigurationData?.Tenant,
            tieneProperty: !!body.productsConfigurationData?.Property,
            leadId: body.leadId,
            leadStatus: body.leadStatus // ✅ Verificar leadStatus en el body
          });


          this.orquestadorService.postOrquestador(body).subscribe(response => {
            if (response) {
              localStorage.removeItem('state_service');
              this.isClicked = false;
              this.router.navigate(['seguros/hogar/arriendo/cotizador/tenemos-tus-datos']);
            }
          });
        });
      }





    } else {
      console.log('Faltan campos obligatorios');
      this.PolicyHolder.markAllAsTouched();
    }
  }

  // Form validation helper
  isValidField(field: string): boolean {
    const control = this.PolicyHolder.get(field);
    return !!(control && control.errors && control.touched);
  }

  // Helper method to get label CSS classes based on field state
  getLabelClasses(field: string): string {
    const control = this.PolicyHolder.get(field);
    if (!control || !control.touched) return ''; // No aplica clases si no ha sido tocado

    if (control.errors && control.touched) {
      return 'label-invalid';
    } else if (control.valid && control.touched) {
      return 'label-valid';
    }
    return '';
  }

  // Get specific field error message
  getFieldError(field: string): string {
    const control = this.PolicyHolder.get(field);
    if (control && control.errors && control.touched) {
      if (control.errors['required']) return 'Asegúrate de llenar este campo';
      if (control.errors['email']) return "Asegúrate de incluir el símbolo '@'";
      if (control.errors['pattern']) {
        if (field === 'nombre') return 'Este campo debe contener únicamente letras';
        if (field === 'celular') return 'Asegúrate de ingresar un número válido de 10 dígitos';
      }
    }
    return '';
  }

  // Validation methods for backward compatibility (if needed)
  isNombreValid(): boolean {
    const control = this.PolicyHolder.get('nombre');
    return control ? control.valid : false;
  }

  isCelularValid(): boolean {
    const control = this.PolicyHolder.get('celular');
    return control ? control.valid : false;
  }

  isCorreoValid(): boolean {
    const control = this.PolicyHolder.get('correo');
    return control ? control.valid : false;
  }

  validateAlpha(event: KeyboardEvent) {
    const regex = /^[A-Za-z\s]+$/;
    const inputChar = event.key;
    if (!regex.test(event.key)  || ['´', '¨', '`', '^', '~'].includes(inputChar)) {
      console.log('entro ff');
      event.preventDefault();
    }
  }

  public validateNumber(event: KeyboardEvent): void {
    const pattern = /^[0-9]$/;
    const inputChar = event.key;

    // Permitir teclas de control (Backspace, Tab, Flechas, Delete)
    if (['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(inputChar)) {
      return;
    }

    // Bloquear caracteres especiales como tildes y diéresis
    if (!pattern.test(inputChar) || ['´', '¨', '`', '^', '~'].includes(inputChar)) {
      console.log('entro xx');
      event.preventDefault();
    }
  }

  validateServiceFailed(){
    if(localStorage.getItem('state_service')){
      this.serviceIsFailed = true;
    }
  }
}
